import React, { useContext, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { toast, ToastContainer } from 'react-toastify'
import { BASE_URL_API } from '../../References/urls'
import AuthContext from '../../store/auth-context'
import styles from './MpaStores.module.css'
import Select from 'react-select'

const MpaStores = props => {
    const { vendorIdentifier } = props
    const authCtx = useContext(AuthContext)
    const [isFetchingStores, setIsFetchingStores] = useState(false)
    const [stores, setStores] = useState([])
    const [storeName, setStoreName] = useState('')
    const [storeAddress, setStoreAddress] = useState('')
    const [isCreatingStore, setIsCreatingStore] = useState(false)
    const [selectedCity, setSelectedCity] = useState(null)
    const [pincode, setPincode] = useState('')
    const [operatingCities, setOperatingCities] = useState([])
    const [isLoadingCities, setIsLoadingCities] = useState(false)

    const getAllVendorsStoreList = async () => {
        setIsFetchingStores(true)
        const getAllVendorsStoreListResponse = await fetch(BASE_URL_API + "/getAllVendorsStoreList",
            {
                method: "POST",
                body: JSON.stringify({
                    token: authCtx.token,
                    vendorIdentifier: vendorIdentifier
                })
            });

        if (!getAllVendorsStoreListResponse.ok) {
            console.log("Something went wrong : Server Error")
        } else {
            const getAllVendorsStoreListRespo = await getAllVendorsStoreListResponse.json()
            if (getAllVendorsStoreListRespo.status === "success") {
                setStores(getAllVendorsStoreListRespo.response)
            } else {
                if (getAllVendorsStoreListRespo.message === "token Expired, please login again!") {
                    authCtx.logout()
                } else {
                    setStores([])
                }
            }

            console.log(getAllVendorsStoreListRespo)
        }
        setIsFetchingStores(false)
    }

    useEffect(() => {
        getAllVendorsStoreList()
    }, [vendorIdentifier])

    const getOperatingLocations = async () => {
        setIsLoadingCities(true)
        try {
            const response = await fetch(BASE_URL_API + "/adminGetOperatingLocations", {
                method: "POST",
                body: JSON.stringify({
                    token: authCtx.token,
                    executiveIdentifier: authCtx.userIdentifier
                })
            })

            if (!response.ok) {
                console.log("Something went wrong : Server Error")
                setOperatingCities([])
            } else {
                const data = await response.json()
                if (data.status === "success" && Array.isArray(data.response)) {
                    const cityOptions = data.response.map(city => ({
                        value: city.ID,
                        label: city.location
                    }))
                    setOperatingCities(cityOptions)
                } else {
                    if (data.message === "token Expired, please login again!") {
                        authCtx.logout()
                    } else {
                        setOperatingCities([])
                    }
                }
            }
        } catch (error) {
            console.error("Error fetching operating locations:", error)
            setOperatingCities([])
        } finally {
            setIsLoadingCities(false)
        }
    }

    useEffect(() => {
        getOperatingLocations()
    }, [])

    const createNewStore = async () => {
        setIsCreatingStore(true)
        const createNewStoreResponse = await fetch(BASE_URL_API + "/createNewStore",
            {
                method: "POST",
                body: JSON.stringify({
                    token: authCtx.token,
                    vendorIdentifier: vendorIdentifier,
                    storeName: storeName,
                    storeAddress: storeAddress,
                    cityIdentifier: selectedCity?.value,
                    cityLabel : selectedCity?.label,
                    pincode: pincode,
                    createdBy: authCtx.userIdentifier
                })
            });

        if (!createNewStoreResponse.ok) {
            console.log("Something went wrong : Server Error")
        } else {
            const createNewStoreRespo = await createNewStoreResponse.json()
            if (createNewStoreRespo.status === "success") {
                setStoreName('')
                setStoreAddress('')
                setSelectedCity(null)
                setPincode('')
                getAllVendorsStoreList()
                toast("Successfully created the store!")
            } else {
                if (createNewStoreRespo.message === "token Expired, please login again!") {
                    authCtx.logout()
                } else {
                    toast(createNewStoreRespo.message)
                }
            }
            console.log(createNewStoreRespo)
        }
        setIsCreatingStore(false)
    }


    return (
        <div className={styles.mainWrapper}>
            <div className={styles.leftWrapper}>
                {isFetchingStores === true ?
                    <div>
                        Fetching stores.. .
                    </div>
                    :
                    <div >
                        <div className={styles.lwHeader}>
                            {stores?.length} stores available!
                        </div>
                        <div className={styles.lwBody}>
                            {stores?.length > 0 ?
                                <div >
                                    {stores?.map((item, index) => (
                                        <Link to={`/manage-stores/${item?.store_id}`} key={index}>
                                            <div className={styles.eachStoreWrapper}>
                                                <div>
                                                    {item?.company_name}
                                                </div>
                                                <div className={styles.storeAddress}>
                                                    {item?.address}
                                                </div>
                                                {item?.store_id}
                                            </div>
                                        </Link>
                                    ))}
                                </div>
                                :
                                <div>
                                    No stores found!
                                </div>
                            }
                        </div>
                        <div className={styles.lwFooter}>
                            <button>Create A New Store</button>
                        </div>

                    </div>
                }
            </div>
            <div className={styles.rightWrapper}>
                <div className={styles.formWrapper}>

                    <div className={styles.formHeader}>
                        Create A New Store
                    </div>
                    <div className={styles.formContainer}>

                        <div className={styles.eachFieldWrapper}>
                            <div className={styles.fieldCaption}>Please enter store name</div>
                            <div className={styles.fieldBox}>
                                <input 
                                    onChange={(e) => setStoreName(e.target.value)}
                                    className={styles.storeName} autoFocus={true} 
                                    placeholder="Please enter the complete store name" 
                                />
                            </div>
                        </div>

                        <div className={styles.eachFieldWrapper}>
                            <div className={styles.fieldCaption}>Please enter store address</div>
                            <div className={styles.fieldBox}>
                                <input 
                                    value={storeAddress}
                                    onChange={(e) => setStoreAddress(e.target.value)}
                                    placeholder="Please enter the complete store address" 
                                />
                            </div>
                        </div>

                        <div className={styles.eachFieldWrapper}>
                            <div className={styles.fieldCaption}>Select City *</div>
                            <div className={styles.fieldBox}>
                                <Select
                                    options={operatingCities}
                                    placeholder="Select city..."
                                    isClearable
                                    isSearchable
                                    value={selectedCity}
                                    onChange={setSelectedCity}
                                    isLoading={isLoadingCities}
                                    styles={{
                                        control: (base) => ({
                                            ...base,
                                            minHeight: '43px',
                                            borderColor: '#e4e7ec',
                                            borderRadius: '4px',
                                            backgroundColor: '#dfdfdf70',
                                            fontSize: '14px',
                                        }),
                                        menu: (base) => ({ ...base, fontSize: '14px' }),
                                        placeholder: (base) => ({ ...base, color: '#9ca3af' }),
                                    }}
                                />
                            </div>
                        </div>

                        <div className={styles.eachFieldWrapper}>
                            <div className={styles.fieldCaption}>Pincode (6 digits) *</div>
                            <div className={styles.fieldBox}>
                                <input 
                                    value={pincode}
                                    onChange={(e) => {
                                        const value = e.target.value.replace(/\D/g, '').slice(0, 6)
                                        setPincode(value)
                                    }}
                                    placeholder="Enter 6-digit pincode"
                                    maxLength={6}
                                    inputMode="numeric"
                                />
                            </div>
                        </div>

                        <div>
                            {isCreatingStore === true ?
                                <button className={styles.loadingBtn}>Hold On! Creating now...</button>
                                :
                                <div className={styles.actionBtnWrapper}>
                                    {storeName.length > 3 && storeAddress.length > 10 && selectedCity && pincode.length === 6 ?
                                        <button onClick={() => createNewStore()} className={styles.createNewActive}>Create Now!</button>
                                        :
                                        <button onClick={() => alert("Please fill all the required fields correctly...")} className={styles.createNewDull}>Create Now</button>
                                    }
                                </div>
                            }
                        </div>

                    </div>
                </div>
            </div>
        </div>
    )
}

export default MpaStores